module.exports = __webpack_public_path__ + "img/logo.95474d39.png";